export default {
  name: 'localeAltaVie', // Change the locale name
  lang1: 'en-ca',
  lang2: 'fr-ca',
  default: 'en-ca'
}


// WEBPACK FOOTER //
// ./src/config/locale.js